module.exports = __webpack_public_path__ + "static/media/empty-pencil.c96427ee.svg";